import type { ApiInvitation } from '@/src/types';

function getByPath(source: Record<string, unknown>, path: string): unknown {
  return path.split('.').reduce<unknown>((acc, part) => {
    if (acc == null) return undefined;
    if (Array.isArray(acc) && /^\d+$/.test(part)) return acc[Number(part)];
    if (typeof acc === 'object') return (acc as Record<string, unknown>)[part];
    return undefined;
  }, source);
}

function formatDate(value: unknown) {
  const date = new Date(String(value));
  if (Number.isNaN(date.getTime())) return '';

  return new Intl.DateTimeFormat('en-IN', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
}

function applyFilter(value: unknown, filter: string): unknown {
  const [name, rawArg] = filter.split(':').map((part) => part.trim());
  if (name === 'formatDate') return formatDate(value);
  if (name === 'uppercase') return String(value ?? '').toUpperCase();
  if (name === 'lowercase') return String(value ?? '').toLowerCase();
  if (name === 'default') return value || rawArg || '';
  return value;
}

export function resolveExpression(expression: string, data: ApiInvitation): unknown {
  const [path, ...filters] = expression.split('|').map((part) => part.trim());
  const source = { ...data, invitation: data } as Record<string, unknown>;
  let value = getByPath(source, path);

  for (const filter of filters) value = applyFilter(value, filter);

  return value;
}

export function injectValue(value: unknown, data: ApiInvitation): unknown {
  if (typeof value !== 'string') return value;

  const exact = value.match(/^\{\{([^}]+)\}\}$/);
  if (exact) return resolveExpression(exact[1].trim(), data);

  return value.replace(/\{\{([^}]+)\}\}/g, (_, expression: string) => {
    const resolved = resolveExpression(expression.trim(), data);
    return resolved == null ? '' : String(resolved);
  });
}

export function isTruthyCondition(condition: unknown, data: ApiInvitation): boolean {
  if (!condition) return true;
  const value = injectValue(condition, data);
  if (Array.isArray(value)) return value.length > 0;
  return Boolean(value);
}
